import { render, staticRenderFns } from "./flats-crm-btns.vue?vue&type=template&id=96d2427e"
import script from "./flats-crm-btns.vue?vue&type=script&lang=js"
export * from "./flats-crm-btns.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-btns.vue?vue&type=style&index=0&id=96d2427e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports